// Выбираем BASE_URL в зависимости от режима сборки
// production → продакшен сервер
// staging/development → тестовый сервер
export const BASE_URL =
  import.meta.env.MODE === 'production'
    ? 'https://widget.colistasystems.ru'
    : 'https://widget.test.colistasystems.ru';
